import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../containers/home/Home";
import PrivacyPolicy from "../containers/privacyPolicy/PrivacyPolicy";
import TermConditions from "../containers/termCondition/TermCondition";

const PublicRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/term-conditions" element={< TermConditions/>} />

      <Route path="/home" element={<Home />} />
      <Route path="/" element={<Home />} />
    </Routes>
  );
};
export default PublicRoutes;
